import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getActivities, getRecentClocks, getWarehouses, isClockedIn,getClock} from '../../reducer';
import {Accordion, Icon, Table} from 'semantic-ui-react';
import moment from 'moment';
import {Translate} from 'react-localize-redux';

class DayOverview extends Component {

    state = {activeIndex: null};

    handleClick = (e, titleProps) => {
        const {index} = titleProps;
        const {activeIndex} = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({activeIndex: newIndex})
    };

    render() {
        const {activeIndex} = this.state;
        return (
            <Translate>
                {({translate}) =>
                    <Accordion styled>
                        <Accordion.Title
                            active={activeIndex === 0}
                            index={0}
                            onClick={this.handleClick}
                        >
                            <Icon name='dropdown'/>
                            Tagesübersicht
                        </Accordion.Title>
                        <Accordion.Content
                            active={activeIndex === 0}
                        >
                            <Table celled stackable style={{textAlign: 'left'}}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>{translate('clock.warehouse.label')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('clock.activities.label')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('general.from')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('general.until')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('general.duration')} [h]</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        this.props.isClockedIn &&
                                            <Table.Row>
                                                <Table.Cell>
                                                    {this.props.warehouses.find((element) => (element.id === this.props.clock.warehouse_id)).name}
                                                </Table.Cell>
                                                <Table.Cell> {translate('clock.activities.' + this.props.activities.find((element) => (element.id === this.props.clock.activity_id)).name)}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(this.props.clock.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD.MM.YYYY ')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    -
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {Math.round(Math.abs(Date.parse(this.props.clock.start) - Date.parse(moment().format('YYYY-MM-DD HH:mm:ss'))) / 36e3) / 100}
                                                </Table.Cell>
                                            </Table.Row>
                                    }
                                    {this.props.recentClocks !== null && this.props.recentClocks.filter((clock)=>moment().startOf('day').diff(moment(clock.start)) < 0 ).map((clock) => (
                                        <Table.Row key={clock.id}>
                                            <Table.Cell>
                                                {this.props.warehouses.find((element) => (element.id === clock.warehouse_id)).name}
                                            </Table.Cell>
                                            <Table.Cell> {translate('clock.activities.' + this.props.activities.find((element) => (element.id === clock.activity_id)).name)}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {moment(clock.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD.MM.YYYY ')}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {moment(clock.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD.MM.YYYY ')}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {Math.round(Math.abs(Date.parse(clock.start) - Date.parse(clock.end)) / 36e3) / 100}
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                                {this.props.recentClocks !== null &&
                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell>Total</Table.HeaderCell>
                                        <Table.HeaderCell/>
                                        <Table.HeaderCell/>
                                        <Table.HeaderCell/>
                                        <Table.HeaderCell>{
                                            this.props.isClockedIn ?
                                                Math.round(this.props.recentClocks.reduce((a, b) => {
                                                    return a + Math.round(Math.abs(Date.parse(b.start) - Date.parse(b.end)) / 36e3)
                                                }, 0) + Math.round(Math.abs(Date.parse(this.props.clock.start) - Date.parse(moment()
                                                    .format('YYYY-MM-DD HH:mm:ss'))) / 36e3)) / 100
                                                :
                                                this.props.recentClocks.reduce((a, b) => {
                                                    return a + Math.round(Math.abs(Date.parse(b.start) - Date.parse(b.end)) / 36e3)
                                                }, 0)}</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                                }
                            </Table>
                        </Accordion.Content>
                    </Accordion>
                }
            </Translate>
        )
    }
}

const mapStateToProps = state => ({
    isClockedIn: isClockedIn(state),
    clock: getClock(state),
    warehouses: getWarehouses(state),
    activities: getActivities(state),
    recentClocks: getRecentClocks(state)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({})
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(DayOverview)



// WEBPACK FOOTER //
// ./src/scenes/Clock/components/DayOverview/index.js